module.exports = __webpack_public_path__ + "static/SQUARE_arial-8b02393c017fa2fec6d5fa787dff4195.jpeg";